export interface Country {
  name: string;
  iso2: string;
  dialCode: string;
  priority?: number;
}

export const countries: Country[] = [
  { name: "United Kingdom", iso2: "GB", dialCode: "+44", priority: 1 },
  { name: "Ireland", iso2: "IE", dialCode: "+353", priority: 2 },
  { name: "United States", iso2: "US", dialCode: "+1", priority: 3 },
  { name: "Afghanistan", iso2: "AF", dialCode: "+93" },
  { name: "Albania", iso2: "AL", dialCode: "+355" },
  { name: "Algeria", iso2: "DZ", dialCode: "+213" },
  { name: "Argentina", iso2: "AR", dialCode: "+54" },
  { name: "Australia", iso2: "AU", dialCode: "+61" },
  { name: "Austria", iso2: "AT", dialCode: "+43" },
  { name: "Bangladesh", iso2: "BD", dialCode: "+880" },
  { name: "Belgium", iso2: "BE", dialCode: "+32" },
  { name: "Brazil", iso2: "BR", dialCode: "+55" },
  { name: "Bulgaria", iso2: "BG", dialCode: "+359" },
  { name: "Canada", iso2: "CA", dialCode: "+1" },
  { name: "China", iso2: "CN", dialCode: "+86" },
  { name: "Colombia", iso2: "CO", dialCode: "+57" },
  { name: "Czech Republic", iso2: "CZ", dialCode: "+420" },
  { name: "Denmark", iso2: "DK", dialCode: "+45" },
  { name: "Egypt", iso2: "EG", dialCode: "+20" },
  { name: "Finland", iso2: "FI", dialCode: "+358" },
  { name: "France", iso2: "FR", dialCode: "+33" },
  { name: "Germany", iso2: "DE", dialCode: "+49" },
  { name: "Greece", iso2: "GR", dialCode: "+30" },
  { name: "Hong Kong", iso2: "HK", dialCode: "+852" },
  { name: "Hungary", iso2: "HU", dialCode: "+36" },
  { name: "India", iso2: "IN", dialCode: "+91" },
  { name: "Indonesia", iso2: "ID", dialCode: "+62" },
  { name: "Israel", iso2: "IL", dialCode: "+972" },
  { name: "Italy", iso2: "IT", dialCode: "+39" },
  { name: "Japan", iso2: "JP", dialCode: "+81" },
  { name: "Malaysia", iso2: "MY", dialCode: "+60" },
  { name: "Mexico", iso2: "MX", dialCode: "+52" },
  { name: "Netherlands", iso2: "NL", dialCode: "+31" },
  { name: "New Zealand", iso2: "NZ", dialCode: "+64" },
  { name: "Nigeria", iso2: "NG", dialCode: "+234" },
  { name: "Norway", iso2: "NO", dialCode: "+47" },
  { name: "Pakistan", iso2: "PK", dialCode: "+92" },
  { name: "Philippines", iso2: "PH", dialCode: "+63" },
  { name: "Poland", iso2: "PL", dialCode: "+48" },
  { name: "Portugal", iso2: "PT", dialCode: "+351" },
  { name: "Romania", iso2: "RO", dialCode: "+40" },
  { name: "Russia", iso2: "RU", dialCode: "+7" },
  { name: "Saudi Arabia", iso2: "SA", dialCode: "+966" },
  { name: "Singapore", iso2: "SG", dialCode: "+65" },
  { name: "South Africa", iso2: "ZA", dialCode: "+27" },
  { name: "South Korea", iso2: "KR", dialCode: "+82" },
  { name: "Spain", iso2: "ES", dialCode: "+34" },
  { name: "Sweden", iso2: "SE", dialCode: "+46" },
  { name: "Switzerland", iso2: "CH", dialCode: "+41" },
  { name: "Taiwan", iso2: "TW", dialCode: "+886" },
  { name: "Thailand", iso2: "TH", dialCode: "+66" },
  { name: "Turkey", iso2: "TR", dialCode: "+90" },
  { name: "Ukraine", iso2: "UA", dialCode: "+380" },
  { name: "United Arab Emirates", iso2: "AE", dialCode: "+971" },
  { name: "Vietnam", iso2: "VN", dialCode: "+84" },
];
